/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AdminValidationMessageLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
